import { createFileRoute } from "@tanstack/react-router";
import EgyptOutsourcingCosts from "@/pages/blog/EgyptOutsourcingCosts";

export const Route = createFileRoute("/blog/egypt-outsourcing-costs")({
  component: EgyptOutsourcingCosts,
});
